export default __webpack_public_path__ + "static/media/imedicina.eb9a210a.svg";